import type { Me } from "../session";

/** The default screen after sign-in. No ticket-specific content yet (#257
 *  is shell-only) — just a welcome and a pointer to what's coming. */
export function DashboardScreen({ me }: { me: Me }) {
  return (
    <section className="screen-placeholder">
      <h2>Welcome, {me.name || me.email || me.sub}</h2>
      <p>
        This is the admin console shell (#257) — the Orders, Inventory, Catalog and
        Users screens over there in the nav are placeholders until #258-261 wire up
        their backends.
      </p>
    </section>
  );
}
